﻿<script setup>
import {defineProps} from 'vue';

defineProps({
  required: {
    default: false,
    type: Boolean
  },
})


</script>

<template>
  <v-label :required="required" class="mb-1 text-gray">
    <slot></slot>
    <span class="text-red" v-if="required"> *</span>
  </v-label>
</template>

<style scoped>

</style>